import { render, staticRenderFns } from "./ProvTradeReq.vue?vue&type=template&id=4a4e352c&scoped=true&"
import script from "./ProvTradeReq.vue?vue&type=script&lang=js&"
export * from "./ProvTradeReq.vue?vue&type=script&lang=js&"
import style0 from "./ProvTradeReq.vue?vue&type=style&index=0&id=4a4e352c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e352c",
  null
  
)

export default component.exports